// extracted by mini-css-extract-plugin
module.exports = {"root":"notebooks-from-rapid_root__7a7J8"};